import 'photoswipe/style.css'
import PhotoSwipe from 'photoswipe'
import Lang from '@/components/Lang'

export default class Lightbox {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Lightbox(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#initLightbox)
    }

    #initLightbox(event) {
        let target = event.target
        let source = event.target.getAttribute('src')

        if (event.target.parentNode.hasAttribute('data-gp-lightbox')) {
            event.preventDefault()
            target = event.target.parentNode
            source = event.target.parentNode.getAttribute('href')
        }

        const img = new Image()
        img.src = source

        const pswp = new PhotoSwipe({
            index: 0,
            dataSource: [
                {
                    src: source,
                    width: target.getAttribute('data-gp-lightbox-width') ?? img.width,
                    height: target.getAttribute('data-gp-lightbox-height') ?? img.height,
                },
            ],
            errorMsg: Lang.get('general.image_cannot_be_loaded'),
        })

        pswp.init()
    }
}
